pnk-select {
  font-weight: 300;
}

.arrow {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-image: url('./assets/black-arrow.svg');
  background-repeat: no-repeat, repeat;
  background-position: calc(100% - 10px);
}

.arrow2 {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-image: url('./assets/white-arrow.svg');
  background-repeat: no-repeat, repeat;
  background-position: calc(100% - 10px);
}

pnk-select[error] .arrow,
pnk-select[disabled] .arrow,
pnk-select[disabled]:not([error]) .arrow2 {
  background-image: url('./assets/white-arrow.svg');
}

pnk-select:not([disabled]):hover .arrow {
  background-image: url('./assets/red-arrow.svg');
}

pnk-select[disabled]:not([error]):hover .arrow2 {
  background-image: url('./assets/red-arrow.svg');
}

pnk-select[disabled] {
  background-color: var(--pnk-disabled-text);
  color: white;
  cursor: not-allowed;
}

pnk-select[error] {
  background-color: var(--pnk-red);
  color: white;
}

pnk-select[error] .arrow {
  background-image: url('./assets/white-arrow.svg');
}

pnk-select[disabled] input {
  background-color: var(--pnk-disabled-text);
}

pnk-select input {
  position: relative;
  z-index: 1;
  background-color: var(--pnk-bg-disabled-base);
  border: 1px solid var(--pnk-border-base-300);
  border-radius: var(--pnk-rounded-md);
  padding: 10px;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  cursor: pointer;
}
.pnk-bg-red {
  background-color: #e82e2c !important;
}
.pnk-bg-option {
  background-color: #e3e3e3 !important;
  width: 256px !important;
  border-radius: 5px !important;
  padding: 5px !important;
}

pnk-select[disabled] input {
  cursor: not-allowed;
}

pnk-select[error] input {
  background-color: var(--pnk-red);
  color: white;
}

pnk-select input:focus {
  border-color: var(--pnk-primary);
  box-shadow: 0 0 0 1px var(--pnk-primary);
}

pnk-select .options-container {
  position: absolute;
  width: 100% !important;
  top: 100%;
  left: 0;
  z-index: 10;
  background-color: white;
  border: 1px solid var(--pnk-border-base-300);
  border-radius: var(--pnk-rounded-md);
  overflow-y: auto;
  max-height: 250px;
}

pnk-select .search-option {
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
  background-color: white;
  margin-bottom: 5px;
  padding: 5px;
}

pnk-select .search-option:hover {
  background-color: #fad5e7;
}
pnk-select .search-option:focus {
  background-color: #fad5e7;
}
